import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot } from "vue"

import { useIonRouter } from '@ionic/vue';
import { chevronBack } from 'ionicons/icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewHeader',
  props: {
  title: {
    type: String,
    required: true,
    default: 'title',
  },
  goBackLink: {
    type: String,
    required: false,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;

const router = useIonRouter();
const goBack = () => {
  if (router.canGoBack()) {
    if (props.goBackLink) {
      router.push({ path: props.goBackLink, direction: 'back' });
    } else {
      router.back();
    }
  } else {
    router.push('/menu');
  }
};


return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!

  return (_openBlock(), _createBlock(_component_ion_header, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_toolbar, {
        class: "mb-1",
        color: "primary"
      }, {
        default: _withCtx(() => [
          (__props.goBackLink)
            ? (_openBlock(), _createBlock(_component_ion_buttons, {
                key: 0,
                slot: "start"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: goBack }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _unref(chevronBack)
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_title, {
            style: _normalizeStyle({ 'padding-inline': __props.goBackLink ? '48px' : '16px' }),
            class: "text-center h4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.title), 1)
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_ion_buttons, { slot: "end" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "actions")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _renderSlot(_ctx.$slots, "subheader")
    ]),
    _: 3
  }))
}
}

})